import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Label } from "reactstrap";
import appURL from "../../../../../appURL.json";
import OpalMultipleTagInput from "../../../../OpalMultipleTagInput/OpalMultipleTagInput";

const EvaluationFieldwork = ({
    account,
    session,
    clients,
    setMaxSubPage,
    setSubPageInComplete,
    answerFactor,
    setAnswerFactor,
    setValidationMessage
}) => {

    const [tags, setTags] = useState(answerFactor.clients || []);
    const [inputValue, setInputValue] = useState("");

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
        }); // e.g., April 1, 2025
    };

    const addTag = (client) => {
        if (!client) return;

        const exists = tags.some(t => t.id === client.id);
        if (!exists) {
            setTags([...tags, client]);
            setAnswerFactor(prev => ({
                ...prev,
                clients: [...tags, client]
            }))
        }

        setInputValue("");
    };

    const removeTag = (newTags) => {  
        setTags(newTags);
        setAnswerFactor(prev => ({
            ...prev,
            clients: newTags
        }));
    };

    // Notify parent that this step has only one subpage (index 0)
    useEffect(() => {
        setMaxSubPage(0);
        setSubPageInComplete(false);
    }, [setMaxSubPage]);


    return (
        <div className="evaluation-fieldwork h-100 d-flex flex-column">
            <div className="label-row">
                <div>
                    <Label className="label-title">AGENT NAME:</Label>
                    <Label>{account?.Name}</Label>
                </div>
                <div>
                    <Label className="label-title">DATE:</Label>
                    <Label>{formatDate(session?.SessionDate)?.toUpperCase()}</Label>
                </div>
            </div>

            <div className="label-row">
                <div className="d-flex align-items-center w-100">
                    <Label className="label-title">CLIENT NAME:</Label>
                    <OpalMultipleTagInput
                        tags={tags}
                        setTags={setTags}
                        addTag={addTag}
                        removeTag={removeTag}
                        inputValue={inputValue}
                        setInputValue={setInputValue}
                        items={clients}
                    />
                </div>
            </div>

            <div className="d-flex align-items-center justify-content-center h-100">
                <div className="text-center w-75">This evaluation presents a summary of performance based on key criteria observed during the assessment period.</div>
            </div>
        </div>
    )
}

export default EvaluationFieldwork